export default __webpack_public_path__ + "static/media/sandwish.bbca03fd.svg";